import base from "/Users/maxbai/Downloads/monochrome-4f57e42d26760d51393bba8812babbedca3c9c02/images/sort.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");